<!--
 * @Author:
 * @LastEditTime: 2024-06-21 13:38:02
 * @Description: 新增、编辑工程
-->
<template>
  <div>
    <el-dialog
      class="mid-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="modelProps.visible"
      :title="modelProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="modelContextForm"
        :rules="modelTreeFormRules"
        ref="modelForm"
        label-width="150px"
        :disabled="modelProps.editType === 'read'"
      >
        <el-form-item :label="`${$t('序号')}`" prop="serialNumber">
          <el-input
            v-model.number="modelContextForm.serialNumber"
            oninput="value = value.replace(/[^\d.]/g,'')"
            :placeholder="`${$t('请选择工程序号')}`"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item :label="`${$t('分类')}`" prop="theEngineeringModelSceneTreeId">
          <el-select
            ref="modelTree"
            v-model="modelContextForm.modelClassName"
            class="mr-10px w-200px"
            popper-class="modeltree__select"
            :popper-append-to-body="false"
            :placeholder="`${$t('请选择工程分类')}`"
            clearable
            filterable
          >
            <el-option
              v-for="item in flatTreeData"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              class="hidden"
            ></el-option>
            <el-tree
              ref="modelClassTree"
              :data="treeData"
              :props="{
                children: 'children',
                label: 'name',
              }"
              :expand-on-click-node="false"
              :default-expanded-keys="['']"
              @node-click="treeNodeClick"
              node-key="id"
              highlight-current
            ></el-tree>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('名称')}`" prop="name">
          <el-input
            v-model.trim="modelContextForm.name"
            :placeholder="`${$t('请选择工程名称')}`"
            size="small"
            clearable
          />
        </el-form-item>
        <el-form-item :label="`${$t('工程标签')}`" prop="label">
          <div class="max-w-440px flex justify-start flex-wrap">
            <el-tag
              class="h-36px mr-10px mb-10px mt-2px flex items-center text-14px"
              v-for="tag in modelContextForm.label"
              @close="handleClose(tag)"
              :key="tag"
              :disable-transitions="false"
              closable
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="!w-84px"
              v-if="inputVisible"
              v-model.trim="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="my-2px inline-block" size="small" @click="showInput">{{
              `+${$t('新标签')}`
            }}</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="`${$t('上传工程文件')}`" prop="engineeringFileId">
          <!-- <form-upload
            v-model="modelContextForm.engineeringFileId"
            :accept="['pprj']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias['engineeringFile']"
            :maxSize="900"
          ></form-upload> -->
          <UploadChunkFile
            v-loading="uploadLoading"
            :element-loading-text="uploadProgressText"
            v-model="modelContextForm.engineeringFileId"
            :maxFileCount="1"
            :fileMaxsize="900"
            :fileAccept="'pprj'"
            :singleFile="true"
            @on-progress="onUploadProgress"
            @on-error="uploadLoading = false"
            @filesUploadComplete="onUploadSuccess"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias['engineeringFile']"
            ref="uploadChunk"
          ></UploadChunkFile>
        </el-form-item>
        <el-form-item :label="`${$t('上传物理文件')}`" prop="physicsFileId">
          <form-upload
            v-model="modelContextForm.physicsFileId"
            :accept="['physic']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias['physicsFile']"
            :maxSize="900"
          ></form-upload>
        </el-form-item>
        <el-form-item :label="`${$t('上传动画文件')}`" prop="animationFileId">
          <form-upload
            v-model="modelContextForm.animationFileId"
            :accept="['animation']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias['animationFile']"
            :maxSize="900"
          ></form-upload>
        </el-form-item>
        <el-form-item :label="`${$t('上传工程贴图')}`" prop="engineeringMapFileId">
          <form-upload
            v-model="modelContextForm.engineeringMapFileId"
            :maxSize="30"
            :accept="['zip']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias['engineeringMapFile']"
          ></form-upload>
        </el-form-item>
        <el-form-item :label="`${$t('上传工程缩略图')}`" prop="engineeringThumbnailFileId">
          <form-upload
            v-model="modelContextForm.engineeringThumbnailFileId"
            :maxSize="10"
            :accept="['png', 'jpg']"
            :disabled="tableFormDisabled"
            :fileMedias="fileMedias['engineeringThumbnailFile']"
          ></form-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="modelProps.editType !== 'read'">
        <el-button
          size="small"
          type="primary"
          @click="save()"
          :loading="saveLoading"
          >{{ $t('保存') }}</el-button
        >
        <el-button size="small" @click="close(false)">{{
          $t('取消')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { EngineeringModelDataApi } from '@wiz-api/cloud-render-management'

import {
  isArray,
  reject,
  map,
  keys,
  eq,
  split,
  cloneDeep,
  fromPairs,
  indexOf,
  includes,
  get,
  assign,
  filter,
  find,
} from 'lodash'
import UploadChunkFile from '@/components/UploadFile/UploadChunkFile'

const engineeringModelDataApi = new EngineeringModelDataApi()

const FormUpload = () => {
  return import('./FormUpload')
}

export default {
  name: 'operateModelDialog',
  components: {
    FormUpload,
    UploadChunkFile,
  },
  props: {
    // 当前选中目录
    currentTreeSelect: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 弹框操作类型
    modelProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: $t('保存'),
          editType: 'create',
        }
      },
    },
    // 查看、编辑表
    modelForm: {
      type: Object,
      default: () => {
        return {
          name: '',
          serialNumber: '',
          theEngineeringModelSceneTreeId: '',
          label: [],
          engineeringFileId: '',
          physicsFileId: '',
          animationFileId: '',
          modelClassName: '',
        }
      },
    },
    // 分类树
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    flatTreeData: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      uploadProgressText: '',
      uploadLoading: false,
      // 表单
      modelContextForm: {
        name: '',
        serialNumber: '',
        theEngineeringModelSceneTreeId: '',
        label: [],
        animationFileId: '',
        physicsFileId: '',
        engineeringFileId: '',
        modelClassName: '',
      },
      // 查看屏蔽标签新增
      inputVisible: false,
      // 标签输入框内容
      inputValue: '',
      // 表单保存状态
      saveLoading: false,
      // 文件列表信息
      fileMedias: {
        engineeringFile: [],
        physicsFile: [],
        animationFile: [],
        engineeringMapFile: [],
        engineeringThumbnailFile: [],
      },
    }
  },
  computed: {
    // 表单校验规则
    modelTreeFormRules() {
      return {
        serialNumber: [
          {
            required: true,
            message: this.$t('请输入序号'),
            trigger: ['blur', 'change'],
          },
        ],
        theEngineeringModelSceneTreeId: [
          {
            required: true,
            message: this.$t('请选择分类'),
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: this.$t('请输入名称'),
            trigger: ['blur', 'change'],
          },
        ],
        animationFileId: [
          {
            required: true,
            message: this.$t('请上传动画文件'),
            trigger: 'change',
          },
        ],
        physicsFileId: [
          {
            required: true,
            message: this.$t('请上传物理文件'),
            trigger: 'change',
          },
        ],
        engineeringFileId: [
          {
            required: true,
            message: this.$t('请上传工程文件'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    onUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },

    onUploadSuccess(file) {
      this.uploadLoading = false
      this.modelContextForm.engineeringFileId = file.id
    },
    // 初始化表单数据
    async initFormData() {
      // 如果为新建自动带上模型库目录信息
      const createInfo = {
        modelClassName: this.currentTreeSelect.path || '',
        theEngineeringModelSceneTreeId: this.currentTreeSelect.id || '',
      }
      const formId = get(this.modelForm, 'id')

      let lableObj = {
        label: [],
      }

      const currentModelObj = {}

      if (includes(['edit', 'read'], this.modelProps.editType) && formId) {
        // 标签转换为数组
        lableObj = {
          label: filter(split(this.modelForm.label, ';'), Boolean),
        }
        // currentModelObj = await this.getFormDetail(formId)
      }

      this.modelContextForm = assign(
        currentModelObj,
        cloneDeep(this.modelForm),
        // 新建传入树路径
        eq(this.modelProps.editType, 'create')
          ? createInfo
          : { modelClassName: this.modelForm.classify },
        // 标签转换为数组
        lableObj
      )
    },
    // 下拉数形点击
    treeNodeClick(data, node) {
      this.modelContextForm.theEngineeringModelSceneTreeId = data.id
      const path = this.getNodePath(node)
      this.modelContextForm.modelClassName = path
      this.$refs.modelTree.blur()
      this.$refs.modelForm.validateField(['theEngineeringModelSceneTreeId'])
    },
    getNodePath(node, path = '') {
      if (node.data.id) {
        path = `/${node.data.name}${path}`
      }
      if (node.parent) {
        path = this.getNodePath(node.parent, path)
      }
      return path
    },
    // 标签删除
    handleClose(tag) {
      if (!isArray(this.modelContextForm.label)) {
        return
      }
      this.modelContextForm.label.splice(indexOf(this.modelContextForm.label, tag), 1)
    },
    // 标签添加聚焦
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 新增标签校验
    handleInputConfirm() {
      if (includes(this.modelContextForm.label, this.inputValue)) {
        this.$message.warning(this.$t('已存在该标签'))
        return
      }
      if (get(this.modelContextForm.label, 'length') > 20) {
        this.$message.warning(this.$t('标签数量已超过最大限制'))
        return
      }
      if (this.inputValue) {
        this.modelContextForm.label.push(this.inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 关闭弹框事件
    close(isUpdated) {
      this.$emit('closeModelDialog', isUpdated)
    },
    // 表单保存
    save() {
      this.$refs.modelForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          const body = {
            ...this.modelContextForm,
            label: this.modelContextForm.label.join(';'),
            serialNumber: String(this.modelContextForm.serialNumber),
            classify: this.modelContextForm.modelClassName,
          }
          if (this.modelProps.editType === 'create') {
            const [err] = await engineeringModelDataApi.create({
              body,
            })
            this.saveLoading = false
            if (!err) {
              this.$message.success(this.$t('新增工程成功'))
              this.close(true)
            }
            return
          }
          const [err] = await engineeringModelDataApi.update(this.modelContextForm.id, {
            body,
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success(this.$t('修改工程成功'))
            this.close(true)
          }
        }
      })
    },
  },
  created() {
    // 初始化表单数据
    this.initFormData()
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .modeltree__select {
    width: 440px;

    .el-select-dropdown__empty {
      display: none;
    }
  }
}
</style>
